import {QuickAddItemType} from "../../../../../app/quick-add/@types"
import {TagType} from "../../../../../core/model2/tag/const"

export default function openNewTag(parentProjectId?: ID) {

    if (parentProjectId) {
        gd.openNew(
            QuickAddItemType.TAG,
            {
                company     : gd.companyId,
                projectId   : parentProjectId,
                type        : TagType.PROJECT
            })
    } else {
        gd.openNew(
            QuickAddItemType.TAG,
            {
                type: TagType.GENERIC
            }
        )
    }
}
